import { FormEvent, useState } from "react";

const email = "a90189829@gmail.com";

export default function ContactMe() {
  const [name, setName] = useState("");
  const [sender, setSender] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const body = `${message.trim()}\n\n보낸 사람: ${name.trim()}\n회신 주소: ${sender.trim()}`;
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(`[포트폴리오 문의] ${subject.trim()}`)}&body=${encodeURIComponent(body)}`;
  }

  return <div className="contact-me"><div><span className="eyebrow">CONTACT ME</span><h3>문의 남기기</h3><p>작성 후 메일 앱이 열립니다. 메일 앱에서 전송을 완료해 주세요.</p><a className="inline-link" href={`mailto:${email}`}>{email} ↗</a></div><form onSubmit={submit}>
    <label htmlFor="contact-name">이름</label><input id="contact-name" value={name} onChange={event => setName(event.target.value)} maxLength={80} required />
    <label htmlFor="contact-email">회신 이메일</label><input id="contact-email" type="email" value={sender} onChange={event => setSender(event.target.value)} maxLength={120} required />
    <label htmlFor="contact-subject">제목</label><input id="contact-subject" value={subject} onChange={event => setSubject(event.target.value)} maxLength={120} required />
    <label htmlFor="contact-message">내용</label><textarea id="contact-message" value={message} onChange={event => setMessage(event.target.value)} maxLength={2000} rows={5} required />
    <button className="button primary" type="submit">메일 앱에서 보내기 ↗</button>
  </form></div>;
}
